export const getSearchExperimentString = () => {
  const useNewIAIndexString = `search-use-new-ia-index=true`
  return `${useNewIAIndexString}`
}
